<nav class="navbar">
    <div class="logo">Tropilleros</div>
    
    <!-- Botón de menú -->
    <div class="menu-toggle" (click)="toggleMenu()">
        <i class="fas" [ngClass]="menuOpen ? 'fa-times' : 'fa-bars'"></i>
    </div>

    <!-- Menú de navegación -->
    <ul class="nav-links" [ngClass]="{ 'active': menuOpen }">
        <li><a href="#home" (click)="closeMenu()">Inicio</a></li>
        <li><a href="#nosotros" (click)="closeMenu()">Nosotros</a></li>
        <li><a href="#musica" (click)="closeMenu()">Música</a></li>
        <li><a href="#gallery" (click)="closeMenu()">Galería</a></li>
        <li><a href="#contacto" (click)="closeMenu()">Contacto</a></li>
    </ul>
</nav>